(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrive-play-style"] && !Shopify.designMode) return;
  try {
    
  // Delegated so it keeps working for sections added or re-rendered by the
  // theme editor without needing to re-bind.
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.thrive-style__tab');
    if (!tab) return;

    const section = tab.closest('.thrive-style');
    if (!section) return;

    section.querySelectorAll('.thrive-style__tab').forEach((other) => {
      const active = other === tab;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    const targetId = tab.getAttribute('aria-controls');
    section.querySelectorAll('.thrive-style__panel').forEach((panel) => {
      const active = panel.id === targetId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  });

  // Variants can differ in price, so the card reflects whichever is selected.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;

    const card = select.closest('.thrive-style__card');
    const price = card && card.querySelector('.thrive-style__price');
    const chosen = select.options[select.selectedIndex];
    if (price && chosen && chosen.dataset.price) price.textContent = chosen.dataset.price;
  });

  // Arrows scroll whichever panel is currently visible.
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-style-scroll]');
    if (!arrow) return;

    const section = arrow.closest('.thrive-style');
    if (!section) return;

    const panel = section.querySelector('.thrive-style__panel:not([hidden])');
    const rail = panel && panel.querySelector('.thrive-style__rail');
    const card = rail && rail.querySelector('.thrive-style__card');
    if (!rail || !card) return;

    const step = (card.offsetWidth + 16) * 2;
    rail.scrollBy({
      left: arrow.dataset.styleScroll === 'prev' ? -step : step,
      behavior: 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrive-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    const update = (root) => {
      const rail = root.querySelector('.thrive-reviews__rail');
      const bar = root.querySelector('[data-review-bar]');
      const current = root.querySelector('[data-review-current]');
      if (!rail) return;

      const max = rail.scrollWidth - rail.clientWidth;
      const ratio = max > 0 ? rail.scrollLeft / max : 0;

      if (bar) {
        const visible = rail.clientWidth / rail.scrollWidth;
        const minWidth = Math.max(visible * 100, 8);
        bar.style.width = `${Math.min(100, minWidth + ratio * (100 - minWidth))}%`;
      }

      if (current) {
        const card = rail.querySelector('.thrive-reviews__card');
        const total = rail.querySelectorAll('.thrive-reviews__card').length;
        if (card && total) {
          const step = card.offsetWidth + 16;
          const index = Math.min(total, Math.round(rail.scrollLeft / step) + 1);
          current.textContent = pad(index);
        }
      }
    };

    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('.thrive-reviews__arrow');
      if (!arrow) return;

      const root = arrow.closest('.thrive-reviews');
      const rail = root && root.querySelector('.thrive-reviews__rail');
      const card = rail && rail.querySelector('.thrive-reviews__card');
      if (!rail || !card) return;

      const step = card.offsetWidth + 16;
      rail.scrollBy({
        left: arrow.dataset.direction === 'prev' ? -step : step,
        behavior: 'smooth',
      });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const rail = event.target.closest && event.target.closest('.thrive-reviews__rail');
        if (rail) update(rail.closest('.thrive-reviews'));
      },
      true
    );

    const init = () => document.querySelectorAll('.thrive-reviews').forEach(update);
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();
})();
